import React from 'react'

interface AppLoadingProps {
  text?: string
}

// Full-screen startup splash. Rendered before the rest of the app (and its
// theme provider) is up, so plain HTML/CSS only — no design-system components.
const AppLoading: React.FC<AppLoadingProps> = ({ text = 'Loading…' }) => (
  <div
    style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      background: 'var(--tma-page-bg, #f2f2f4)',
      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
    }}
  >
    <div
      style={{
        width: '36px',
        height: '36px',
        border: '3px solid var(--tma-card-border, #dcdce0)',
        borderTopColor: 'var(--tma-accent, #416eec)',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}
    />
    <div style={{ fontSize: '16px', fontWeight: 600, color: 'var(--tma-text-strong, #191b1f)' }}>Tenants Management Application</div>
    <div style={{ fontSize: '13px', color: 'var(--tma-text-muted, #666)' }}>{text}</div>
  </div>
)

export default AppLoading
